import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ViewMode } from 'core/structs/ViewMode'
import { TextDirection } from 'core/theme/ThemeContext'
import { PdfJs } from 'core/types'

interface pdfState {
  pdfInfo: {
    currentPage: number
    doc: PdfJs.PdfDocument | any
    pageHeight: number
    pageWidth: number
    rotation: number
    viewMode: ViewMode
    direction: TextDirection
    singlePages: number[]
    pagesChunk: number[][]
  },
  isFindHyperLink: boolean
  // eslint-disable-next-line no-unused-vars
  jumpPagePdf?: (pageIndex: number) => Promise<void>
  jumpToNextPage?: () => void
  jumpToPreviousPage?:() => void
}

const initialState: pdfState = {
  pdfInfo: {
    currentPage: 0,
    doc: null,
    pageHeight: 0,
    pageWidth: 0,
    rotation: 0,
    viewMode: ViewMode.SinglePage,
    direction: TextDirection.LeftToRight,
    singlePages: [],
    pagesChunk: []
  },
  isFindHyperLink: false
}

export const pdfStoreSlice = createSlice({
  name: 'pdf',
  initialState,
  reducers: {
    setCurrentPageRedux: (
      state,
      action: PayloadAction<{
        currentPage: number
      }>
    ) => {
      state.pdfInfo.currentPage = action.payload.currentPage
    },
    setPdfInfo: (
      state,
      action: PayloadAction<{
        currentPage?: number
        doc?: PdfJs.PdfDocument
        pageHeight?: number
        pageWidth?: number
        rotation?: number
        viewMode?: ViewMode
        direction?: TextDirection
        singlePages?: number[],
        pagesChunk?: number[][]
      }>
    ) => {
      state.pdfInfo = {
        ...state.pdfInfo,
        ...action.payload
      }
    },
    setJumpPagePdf: (state, action: PayloadAction<any>) => {
      state.jumpPagePdf = action.payload
    },
    setJumpToNextPage: (state, action: PayloadAction<any>) => {
      state.jumpToNextPage = action.payload
    },
    setJumpPreviousPage: (state, action: PayloadAction<any>) => {
      state.jumpToPreviousPage = action.payload
    },
    setIsFindHyperLinkRedux: (state, action: PayloadAction<boolean>) => {
      state.isFindHyperLink = action.payload
    }
  }
})
export const { setCurrentPageRedux, setPdfInfo, setJumpPagePdf, setJumpToNextPage, setJumpPreviousPage, setIsFindHyperLinkRedux } = pdfStoreSlice.actions
export default pdfStoreSlice.reducer
